/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-11 16:07:24
 * @FilePath: /insuranceagent-ui/src/const/enum.js
 * @Description:
 */
/**
 * 投保区分
 * operate  ：（1=投保；2=批增；3=替换；4=附加方案投保；5=附加方案批准）
 * 投保提醒增加一个批改场景字段，changeScene：
 * 批改场景（101、新增雇员，102、替换雇员，103、删除雇员；104、修改雇员；401、修改投保人；402、修改被保人;
 * 403、新增共同被保人404、批减被保人；901、批减人员;902、批减车辆;903、批改工种；904、批改投保座位数；
 * 905、批改保额；201、退保;801、线下新增;802、线下替换;803、批减人员;804、批改工种；805、批改特约）
 *
 */

/**
 * 投保方式类型
 */
export const EnumInsureType = {
	new: 'new', //新投保
	add: 'add', //批增
	addResubmit: 'addResubmit', //批增重新提交
	renew: 'renew', //续保
	resubmit: 'resubmit', //重新提交
	plan: 'plan', //计划书投保
	staging: 'staging', //暂存投保
	change: 'change', //替换
}
/**
 * 新域名跳转类型
 *
 */
export const EnumInsureUrlType = {
	insure: 'insure',
	change: 'change', //替换
	add: 'add', //批增
	addInsured: 'addInsured', //新增共保人
	editSingleInsured: 'editSingleInsured', //修改共保人
	editMoreInsured: 'editMoreInsured', //修改批量共保人
	addMoreInsured: 'addMoreInsured', //新增批增共保人
	detail: 'detail', //详情
	pay: 'pay', //支付
	policyList: 'policyList', //保单列表
}

/**
 * 通过投保方式获取URL
 * @param type
 * @returns {string}
 */
export function getEnumUrlType(type) {
	switch (type) {
		case EnumInsureType.new:
		case EnumInsureType.renew:
		case EnumInsureType.resubmit:
		case EnumInsureType.plan:
		case EnumInsureType.staging:
			//投保
			return EnumInsureUrlType.insure
		case EnumInsureType.add:
			return EnumInsureUrlType.add
		case EnumInsureType.change:
			return EnumInsureUrlType.change
	}
	return ''
}

export const EnumCouponStatus = {
	UNUSED: 'UNUSED', //未使用
	USED: 'USED', //已使用
	UNUSED_ABLE: 'UNUSED_ABLE', // 不可用
	UNUSED_GUO: 'UNUSED_GUO', //已过期'
}

//日志类型
export const EnumLogType = {
	//博维吉泰必读条款
	logInsureNotices: 'logInsureNotices',
	//发票是否已下载
	logInvoiceDownload: 'logInvoiceDownload',
	//批单是否已下载
	logEndorsementDownload: 'logEndorsementDownload',
	//保单是否已下载
	logPolicyPdfDownload: 'logPolicyPdfDownload',
}

//==================================结算==================================
// 结算方式枚举
export const SettleType = {
	PUBLIC: 'PUBLIC', // 服务对公
	INTER: 'INTER', // 中介对公
	PRIVATE: 'PRIVATE', // 第三方清分
	AGENT: 'AGENT', // 代理人佣金
}

// 结算周期枚举
export const SettlePeriod = {
	MONTH: 'MONTH', // 月结
	SEMI_MONTH: 'SEMI_MONTH', // 半月结
}

// 结算打款账户枚举
export const SettleRemitAccount = {
	MB: 'MB', // 广州美保科技有限公司
	MBJJ: 'MBJJ', // 广东美保保险经纪有限公司
	LG: 'LG', // 蓝工科技
}
